<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isLiked: boolean
    likeCount?: number
    loading?: boolean
    activeColorClass?: string
    inactiveColorClass?: string
    iconClasses?: string
    classes?: string | Array<string | Record<string, boolean>> | Record<string, boolean>
  }>(),
  {
    loading: false,
    activeColorClass: 'tw-text-riser-blue',
    inactiveColorClass: 'tw-text-black/30'
  }
)

const emit = defineEmits(['click', 'countClick'])

const { t } = useI18n()
const { requireLogin } = useAuthGate()

const click = () => {
  requireLogin(() => emit('click'))
}

const countClick = () => {
  emit('countClick')
}
</script>

<template>
  <InputAppButton
    :loading="props.loading"
    class="tw-inline-flex tw-items-center tw-gap-2"
    :class="props.classes"
    data-testid="like-button"
    @click="click"
  >
    <div class="tw-flex tw-items-center tw-gap-1">
      <slot>
        <span class="tw-text-sm tw-text-black/60">{{ props.isLiked ? '' : t('Like') }}</span>

        <IconsFlame
          :class="[
            props.isLiked ? props.activeColorClass : props.inactiveColorClass,
            props.iconClasses
          ]"
        />
      </slot>
    </div>

    <!-- pt-1 is to visually align the text with the flame icon -->
    <div v-if="props.likeCount" class="tw-pt-1 tw-leading-none" @click.stop="countClick">
      <span class="tw-font-bold">
        {{ formatUserNumber(props.likeCount) }}
      </span>

      <span class="tw-opacity/70">
        {{ t('%d people like this') }}
      </span>
    </div>
  </InputAppButton>
</template>
